
import { InterfaceMonitoringDtlEntity } from "domain/entity/InterfaceMonitoring/InterfaceMonitoringDtlEntity";
import { EMPTY_INTERFACE_MONITORING_ENTITY, InterfaceMonitoringEntity } from "domain/entity/InterfaceMonitoring/InterfaceMonitoringEntity";
import { EMPTY_INTERFACE_MONITORING_SEARCH_CRITERIA, InterfaceMonitoringSearchCriteria } from "domain/entity/InterfaceMonitoring/InterfaceMonitoringSearchCriteria";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface EbisInterfaceMonitoringDropdownOptions {
    messageTypeDropdownOptions: DropdownProps[],
    formDropdownOptions: DropdownProps[],
    toDropdownOptions: DropdownProps[],
    statusDropdownOptions: DropdownProps[],
}
export interface EbisInterfaceMonitoringChangeState extends BaseViewChangeSate {
}

export interface EbisInterfaceMonitoringMaintenanceModel {
    isLoading: boolean,
    tableData: InterfaceMonitoringEntity[],
    currentSelectedRow: InterfaceMonitoringEntity,
    selectedRows: InterfaceMonitoringEntity[],
    ebisInterfacemonitoringDtlList: InterfaceMonitoringDtlEntity[],
    dynamicOptions: EbisInterfaceMonitoringDropdownOptions,
    viewState: EbisInterfaceMonitoringChangeState,
    isShowDetailPanel: boolean,
    isShowSearchPanel: boolean,
    searchCriteria: InterfaceMonitoringSearchCriteria,
    forceRefresh: boolean,
    isSearchLoading: boolean,
}

export const EMPTY_EBIS_INTERFACE_MONITORINGANY_MODEL: EbisInterfaceMonitoringMaintenanceModel = {
    isLoading: false,
    tableData: [],
    currentSelectedRow: { ...EMPTY_INTERFACE_MONITORING_ENTITY },
    selectedRows: [],
    searchCriteria: { ...EMPTY_INTERFACE_MONITORING_SEARCH_CRITERIA },
    ebisInterfacemonitoringDtlList: [],
    dynamicOptions: {
        messageTypeDropdownOptions: [],
        formDropdownOptions: [],
        toDropdownOptions: [],
        statusDropdownOptions: [],
    },
    viewState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        },
    },
    isShowDetailPanel: false,
    isShowSearchPanel: false,
    forceRefresh: false,
    isSearchLoading: true,
}